module.exports = {
    ACCOUNTS: 'account',
    CARDS: 'card',
    LOANSANDMORTGAGES: 'loanandmortgage',
    DEPOSITS: 'deposit',
    INVESTMENTS: 'investment'
};
